export const schedule = [
  // Week 0
  {
    date: "02/02 Tu",
    topic: "Introduction and a Brief Overview of the Interview Process",
    slides:
      "https://docs.google.com/presentation/d/1_y4kxhhoTWpjNr9CDmBoS1fuj5DwcWH_SKWitKxNHlc/edit?usp=sharing",
    video:
      "https://drive.google.com/file/d/1MbAQTcs3UPtHU1SkI2eaR_2BQS_1X0zI/view?usp=sharing",
    problems: [],
    sectionName: "",
    sectionProblem: "",
    homework: "Get a LeetCode Account",
    due: "02/08 Mon",
  },
  // Week 1
  {
    date: "02/09 Tu",
    topic: "Basic Data Structures and Problem Solving",
    slides: "https://docs.google.com/presentation/d/1hP6Q7hT0zgqmuDwDAtDVEQslfIrOci6XqsLjsZRrnMs/edit?usp=sharing",
    video: "https://drive.google.com/file/d/1gGYYHDCI7mAPXDF1dPAffMicPaPvy6TH/view?usp=sharing",
    sectionName: "Valid anagram",
    sectionProblem: "https://leetcode.com/problems/valid-anagram/",
    sectionInfo: "https://drive.google.com/file/d/1tj6Lx6M3X-zhUT7ENWdL37qfKPd-U0hE/view?usp=sharing",
    problems: [
      {
        name: "Two Sum",
        link: "https://leetcode.com/problems/two-sum/"
      },
      {
        name: "Contains duplicate",
        link: "https://leetcode.com/problems/contains-duplicate/"
      },{
        name: "[Solution] Contains duplicate",
        link: "https://www.youtube.com/watch?v=u0EODaL6wQE&list=PLqscWxznaF7fjTcZ5nFj5oe7_bs6fMLzj"
      },
      {
        name: "Best time to buy and sell stock",
        link: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/"
      },
      {
        name: "Merge Intervals",
        link: "https://leetcode.com/problems/merge-intervals/"
      },
      {
        name: "Product of array except self",
        link: "https://leetcode.com/problems/product-of-array-except-self/"
      },
      {
        name: "[Solution] Product of array except self",
        link: "https://www.youtube.com/watch?v=wNi-xFJ9pOk&list=PLqscWxznaF7fjTcZ5nFj5oe7_bs6fMLzj&index=4"
      },
      {
        name: "[Solution] Valid Anagram",
        link: "https://www.youtube.com/watch?v=9dEAZFF4CRc&list=PLqscWxznaF7fjTcZ5nFj5oe7_bs6fMLzj&index=2"
      },
    ],
    homework: "Homework 2",
    due: "02/15 Mon",
  },
  // Week 2
  {
    date: "02/16 Tu",
    topic: "Linked Lists",
    slides:
      "https://drive.google.com/file/d/14R6qUDgQVJ8j-DQoZRc2WvQqvb6kIyhb/view?usp=sharing",
    video: "https://drive.google.com/file/d/1l_Yt-S4r7xo0P_pxly2iQgu-aN8E4zZQ/view?usp=sharing",
    sectionName: "Add Two Numbers",
    sectionProblem: "https://leetcode.com/problems/add-two-numbers/",
    sectionInfo: "https://drive.google.com/file/d/15CcsKRmcWTTdJIlfMYRySVI-JBQn5b87/view?usp=sharing",
    extraPracticeName: "Merge K Sorted Lists",
    extraPracticeProblem: "https://leetcode.com/problems/merge-k-sorted-lists/",
    problems: [
      {
        name: "Reverse a Linked List",
        link: "https://leetcode.com/problems/reverse-linked-list/",
      },
      {
        name: "Reverse Linked List ii",
        link: "https://leetcode.com/problems/reverse-linked-list-ii/",
      },
      {
        name: "[Solution] Reverse Linked List ii",
        link: "https://www.youtube.com/watch?v=ZiZqqvqEnrs",
      },
      {
        name: "Flatten a multilevel linkedlist",
        link: "https://leetcode.com/problems/flatten-a-multilevel-doubly-linked-list/",
      },
      {
        name: "[Solution] Flatten a multilevel linkedlist",
        link: "https://youtu.be/Ly1EEJWMLfk",
      },
      {
        name: "Remove nth node from end",
        link: "https://leetcode.com/problems/remove-nth-node-from-end-of-list/",
      },
      {
        name: "[Solution] Remove nth node from end",
        link: "https://youtu.be/LC0y6w4amhg",
      },
      {
        name: "Merge 2 sorted lists",
        link: "https://leetcode.com/problems/merge-two-sorted-lists/",
      },
    ],
    homework: "Homework 3",
    due: "02/22 Mon",
  },
  // Week 3
  {
    date: "02/23 Tu",
    topic: "Binary Search Problems",
    slides: "https://docs.google.com/presentation/d/1sERfk11BGveocEtbrDBMHdiiYWmzcCLu4talOa4yMgw/edit?usp=sharing",
    video: "https://drive.google.com/file/d/1OUpHH2q1DL96tEE1bwyz7R54148C4uvJ/view?usp=sharing",
    sectionName: "Search 2D Matrix",
    sectionProblem: "https://leetcode.com/problems/search-a-2d-matrix/",
    sectionInfo: "https://drive.google.com/file/d/1bJyD0rroXIbxU1c05xswFMiJ3zj8-iqi/view?usp=sharing",
    extraPracticeName: "Kth Smallest Element in a Sorted Matrix",
    extraPracticeProblem: "https://leetcode.com/problems/kth-smallest-element-in-a-sorted-matrix/",
    problems: [
      {
        name: "First & last pos in sorted arr",
        link: "https://leetcode.com/problems/find-first-and-last-position-of-element-in-sorted-array/",
      },
      {
        name: "[Solution] First & last pos in sorted arr",
        link: "https://youtu.be/0yktIGutogE",
      },
      {
        name: "Search Insert Position",
        link: "https://leetcode.com/problems/search-insert-position/",
      },
      {
        name: "[Solution] Search Insert Position",
        link: "https://youtu.be/SQfFsQbZUfs",
      },
      {
        name: "Search in rotated sorted arr",
        link: "https://leetcode.com/problems/search-in-rotated-sorted-array/",
      },
      {
        name: "[Solution] Search in rotated sorted arr",
        link: "https://youtu.be/19thO-YJcN4",
      },
      {
        name: "Random pick with weight",
        link: "https://leetcode.com/problems/random-pick-with-weight/",
      },
      {
        name: "[Solution] Random pick with weight",
        link: "https://youtu.be/7UY2XbFcW5A",
      },
      {
        name: "Find smallest divisor w/ threshold",
        link: "https://leetcode.com/problems/find-the-smallest-divisor-given-a-threshold/",
      },
      {
        name: "[Solution] Find smallest divisor w/ threshold",
        link: "https://youtu.be/F50a7MiIkrE",
      },
    ],
    homework: "Homework 4",
    due: "03/01 Mon",
  },

  // Week 4
  {
    date: "03/02 Tu",
    topic: "Intermediate Data Structures: Stacks, Queues, and Heaps",
    slides: "https://drive.google.com/file/d/14ftsvFSxhOVJtO__Teu7089h_60AI5a-/view?usp=sharing",
    video: "https://drive.google.com/file/d/1t09nztm0nwN5rhWPWCDNdK-bo8_2FYA8/view?usp=sharing",
    sectionName: "Decode string",
    sectionProblem: "https://leetcode.com/problems/decode-string/",
    // sectionInfo: "",
    problems: [
      {
        name: "Valid Parentheses",
        link: "https://leetcode.com/problems/valid-parentheses/",
      },
      {
        name: "[Solution] Valid Parentheses",
        link: "https://youtu.be/8pI2EWjAXmM",
      },
      {
        name: "Minimum to Remove to Make Valid",
        link: "https://leetcode.com/problems/minimum-remove-to-make-valid-parentheses/",
      },
      {
        name: "K Closest Points to Origin",
        link: "https://leetcode.com/problems/k-closest-points-to-origin/",
      },
      {
        name: "LRU Cache",
        link: "https://leetcode.com/problems/lru-cache/",
      },
      {
      name: "Task Scheduler",
      link: "https://leetcode.com/problems/task-scheduler/",
      },
    ],
    homework: "Homework 5",
    due: "03/08 Mon",
  },
  // Week 5
  {
    date: "03/09 Tu",
    topic: "Object Oriented Programming",
    sectionName: "Design Browser History",
    slides: "https://docs.google.com/presentation/d/14jXtINZvp6KJp1d7fy6dM8WXBWDgMUDom9OiKThFvp0/edit?usp=sharing",
    video: "https://drive.google.com/file/d/1HXKAUA5W0MmrBJ6KsNGLHGK8vKR242KX/view?usp=sharing",
    sectionProblem: "https://leetcode.com/problems/design-browser-history/",
    problems: [
      {
        name: "Min Stack",
        link: "https://leetcode.com/problems/min-stack/",
      },
      {
        name: "[Solution] Min Stack",
        link: "https://www.youtube.com/watch?v=3dN1dwbufDg",
      },
      {
        name: "Design Underground Subway System",
        link: "https://leetcode.com/problems/design-underground-system/",
      },
      {
        name: "Design Underground Subway System",
        link: "https://www.youtube.com/watch?v=Vom-eJy6hWs",
      },
      {
        name: "Design Twitter",
        link: "https://leetcode.com/problems/design-twitter/",
      },
      {
        name: "Design Hashset",
        link: "https://leetcode.com/problems/design-hashset/",
      },
      {
        name: "Encode and Decode TinyURL",
        link: "https://leetcode.com/problems/encode-and-decode-tinyurl/",
      },
    ],
    homework: "Homework 6",
    due: "03/15 Mon",
    
  },
  // Week 6
  {
    date: "03/16 Tu",
    topic: "Two Pointers/Sliding Window",
    extra: "Mock Interview I",
    slides: "https://docs.google.com/presentation/d/1BcAKpGMKZWAqwx4uo1N7FUbtsSOPNZ2RAnKzCrL3Vp0",
    video: "https://drive.google.com/file/d/19LA3GX8YjfhSvWOR43dU7BcH-UTTbnoY/view?usp=sharing",
    sectionName: "Swapping Nodes in a Linked List",
    sectionProblem: "https://leetcode.com/problems/swapping-nodes-in-a-linked-list/",
    
    interviewHelp: [
        {
            name: "Problem 1",
            link: "https://docs.google.com/document/d/15tl8bdDm9IdipFOdXIsy7puLlo3VcoyCxN3wc-6tsIE/edit#",
            solution: "https://www.youtube.com/watch?v=KVMffdODBJI"
        },
        {
            name: "Problem 2",
            link: "https://docs.google.com/document/d/1oHgvt76_sAM6z5khjQyN7ek-iDupWHRytumF3jIcWbQ/edit?usp=sharing",
            solution: "https://www.youtube.com/watch?v=pObhgBa-lT4"
        },
        {
            name: "Example Mock Interview",
            link: "https://youtu.be/SxP6BeaG3cw"
        }
    ],

    problems: [
        {
            name: "Longest Substring without Repeating Characters",
            link: "https://leetcode.com/problems/longest-substring-without-repeating-characters/",
        },
        {
            name: "Maximum Points Obtain from Cards",
            link: "https://leetcode.com/problems/maximum-points-you-can-obtain-from-cards/",
        },
        {
            name: "Maximum Continuous Ones",
            link: "https://leetcode.com/problems/max-consecutive-ones-iii/",
        },
        {
            name: "Permutation in String",
            link: "https://leetcode.com/problems/permutation-in-string/",
        },
        {
            name: "Minimum Window Substring",
            link: "https://leetcode.com/problems/minimum-window-substring/",
        },
    ],
    
    homework: "Homework 7",
    due: "03/29 Mon",
  },
  // Week 7
  {
    date: "03/23 Tu",
    topic: "Spring Break",
    // sectionName: "Add Two Numbers",
    // sectionProblem: "https://leetcode.com/problems/add-two-numbers/",
    problems: [
      {
        name: "",
        link: "",
      },
    ],
    homework: "No Homework! Enjoy your break.",
    // due: "",
  },
  // Week 8
  {
    date: "03/30 Tu",
    topic: "Trees",
    video: "https://drive.google.com/file/d/1t9usi7xu-Rj0nCgreyWkKr_aKNKJnPM6/view?usp=sharing",
    sectionName: "Symmetric Tree",
    sectionProblem: "https://leetcode.com/problems/symmetric-tree",
    slides: "https://docs.google.com/presentation/d/1_P8kT0YJf09k453nbZsxFQtyNSq4yPac8Wbxz4Pp_XA/edit?usp=sharing",
    problems: [
      {
          name: "Same Tree",
          link: "https://leetcode.com/problems/same-tree/",
      },
      {
          name: "Kth Smallest Element in a BST",
          link: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/",
      },
      {
          name: "Maximum Depth of a Binary Tree",
          link: "https://leetcode.com/problems/maximum-depth-of-binary-tree/",
      },
      {
          name: "Diameter of a Binary Tree",
          link: "https://leetcode.com/problems/diameter-of-binary-tree/",
      },
      {
          name: "Right Side Binary Tree",
          link: "https://leetcode.com/problems/binary-tree-right-side-view/",
      },
    ],
    homework: "Homework 8",
    due: "04/06 Tuesday",
  },
  // Week 9
  {
    date: "04/06 Tu",
    topic: "Graphs",
    sectionName: "Shortest Path in Binary Matrix",
    sectionProblem: "https://leetcode.com/problems/shortest-path-in-binary-matrix/",
    slides: "https://docs.google.com/presentation/d/1udRh1yzC4X5C_ukpvIhRUbLlNb3DfpZa5518nbAPUus/edit?usp=sharing",
    video: "https://drive.google.com/file/d/1lww0AKEkXcx8rcyIaEeinrcq80cCqSb6/view?usp=sharing",
    problems: [
      {
        name: "Course Schedule",
        link: "https://leetcode.com/problems/course-schedule/",
      },
      {
        name: "Word Search",
        link: "https://leetcode.com/problems/word-search/",
      },
      {
        name: "Number of Islands",
        link: "https://leetcode.com/problems/number-of-islands/",
      },
      {
        name: "Rotting Oranges",
        link: "https://leetcode.com/problems/rotting-oranges/",
      },
    ],
    homework: "Homework 9",
    due: "04/12 Mon",
  },
  // Week 10
  {
    date: "04/13 Tu",
    topic: "Dynamic Programming",
    sectionName: "House Robber",
    slides: "https://docs.google.com/presentation/d/10Uj8iKfvrzJU_XIunrJj987aH1GJz2fk1EE0eM7twI4/edit?usp=sharing",
    sectionProblem: "https://leetcode.com/problems/house-robber/",
    extraPracticeName: "Maximal Square",
    extraPracticeProblem: "https://leetcode.com/problems/maximal-square/",
    video: "https://drive.google.com/file/d/1Ssjq4evYSJRFm8iFnc7E9IU2cJIn6qI5/view?usp=sharing",
    problems: [
      {
        name: "Decode ways",
        link: "https://leetcode.com/problems/decode-ways/",
      },
      {
        name: "Maximum subarray sum",
        link: "https://leetcode.com/problems/maximum-subarray/",
      },
      {
        name: "Longest Palindromic Substring",
        link: "https://leetcode.com/problems/longest-palindromic-substring/",
      },
      {
        name: "Partition Equal Subset Sum",
        link: "https://leetcode.com/problems/partition-equal-subset-sum/",
      },
      {
        name: "Longest common subsequence",
        link: "https://leetcode.com/problems/longest-common-subsequence/",
      },
    ],
    homework: "Homework 10",
    due: "04/19 Mon",
  },
  // Week 11
  {
    date: "04/20 Tu",
    topic: "Greedy",
    slides: "https://docs.google.com/presentation/d/1nWLHCvRX7WVPfGzqb1LyrCRbTn7zHUocFYcITgc4nMc/edit?usp=sharing",
    sectionName: "Partition Labels",
    sectionProblem: "https://leetcode.com/problems/partition-labels/",
    video: "https://drive.google.com/file/d/1uqAnsUxiis_qTFAlAz7snbdcJUCpxuqD/view?usp=sharing",
    problems: [
      {
        name: "Gas Station",
        link: "https://leetcode.com/problems/gas-station/",
      },
      {
        name: "Task Scheduler",
        link: "https://leetcode.com/problems/task-scheduler/",
      },
      {
        name: "Boats to Save People",
        link: "https://leetcode.com/problems/boats-to-save-people/",
      },
    ],
    homework: "Homework 11",
    due: "04/26 Mon",
  },
  // Week 12
  {
    date: "04/27 Tu",
    topic: "Guest Speaker",
    extra: "Mock Interview II",
    video: "https://drive.google.com/file/d/14EBywAYYymYzCGbvboi2LMIGKlAW4y_V/view?usp=sharing",
    sectionName: "Check out AddisCoder",
    sectionProblem: "https://www.addiscoder.com/",
    problems: [],
  },
];
